export default __webpack_public_path__ + "static/media/4-2_image22@2x.64d7a5c7.png";